import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import * as $cache from "@/utils/cache";
import Router from "@/router";
import { Message } from 'element-ui';
import $api from "@/api";
import FormStatus from './formStatus';
import deepRouterFunc from "@/router/renderFunc.js";
import renderAuthority from "../utils/renderAuthority.js";

export default new Vuex.Store({
    modules: { FormStatus },
    state: {
        isLogin: false,//登录状态
        userLoginInfo: {},//登录者的本地信息
        AuthorityMenu: [],//动态的权限菜单
        // DynamicRoutes: [],//动态路由
        AuthorityBtnsByAllPage: {},//页面的动态权限
        tags: [],//header部分的动态标签，路由卡片,[{title:"",path:""}]
        permission_menuList: [],//用户的权限列表
        allAuthority_menuList: [],//所有的权限列表
        deptList: [],//所有的部门列表
        deptList_tree: [],//树状结构的所有部门
        deptHeadID: '-1',//部门根节点id，根据接口返回head字段动态配置
        token: "",//登陆者
    },
    getters: {
        getIsLogin: (state) => state.isLogin,
        getAuthorityMenu: (state) => state.AuthorityMenu,
        // getDynamicRoutes: (state) => state.DynamicRoutes,
        getAuthorityBtnsByAllPage: (state) => state.AuthorityBtnsByAllPage,
        getAuthorityBtnsByPage: (state) => {
            //单个页面的权限按钮
            return (pagePath) => {
                return state.AuthorityBtnsByAllPage[pagePath] || [];
            }
        },
        getUserLoginInfo: (state) => state.userLoginInfo,
        getTags: (state) => state.tags,
        getPermission_menuList: (state) => state.permission_menuList,
        getAllAuthority_menuList: (state) => state.allAuthority_menuList,
        getDept_List: (state) => state.deptList,
        getDept_List_Tree: (state) => state.deptList_tree,
        getDeptHeadID: (state) => state.deptHeadID,
        getToken: (state) => state.token,

    },
    mutations: {
        setToken: (state, str) => state.token = str,
        setIsLogin: (state, bool) => state.isLogin = bool,//登录
        setLogout: (state) => state.isLogin = false,//退出登录
        setUserLoginInfo: (state, infoObj) => state.userLoginInfo = infoObj,//缓存登录者信息
        setAuthorityMenu: (state, payload) => state.AuthorityMenu = payload,//权限菜单
        // setDynamicRoutes: (state, payload) => state.DynamicRoutes = payload,
        setAuthorityBtnsByAllPage: (state, payload) => state.AuthorityBtnsByAllPage = payload,//权限按钮
        addTag(state, cardObj = {}) {
            const path = cardObj.path;
            const arr = state.tags || [];
            const isExist = arr.some(item => item.path == path);
            if (isExist) return;
            arr.push(cardObj);
            state.tags = arr;
        },
        removeTag(state, cardPath = "") {
            const arr = state.tags || [];
            const tags = arr.filter(item => item.path != cardPath);
            state.tags = tags;
            const len = tags.length;
            len != 0 && Router.push(tags[len - 1].path);
        },
        clearTag: (state) => state.tags = [],
        setPermission_menuList: (state, payload) => state.permission_menuList = payload,//用户的权限列表
        setAllAuthority_menuList: (state, payload) => state.allAuthority_menuList = payload,//所有的权限列表
        setDeptList: (state, payload) => state.deptList = payload,
        setDeptHeadID: (state, id) => state.deptHeadID = '' + id,
        setDeptList_formatTree: (state, payload) => {
            //将一级菜单递归成树状结构
            const apiData = payload;
            const { head, sysDeptEntityList } = apiData;
            state.deptHeadID = '' + head;
            const rootNode = sysDeptEntityList.find(item => item.id == head);
            const parentId = rootNode && ('' + rootNode.parentId) || "-1";
            let result = [
                {
                    label: "根节点",
                    value: parentId,
                    params: { id: parentId },
                    children: []
                }
            ];
            // const result = [
            //     {
            //         label: rootNode.deptName,
            //         value: head,
            //         params: rootNode,
            //         children: [],
            //     }
            // ]

            const deepFunc = (parentId, otherData = []) => {
                const isArray = Array.isArray(otherData);
                if (!isArray || (isArray && otherData.length == 0)) return [];
                let tempOtherData = otherData.filter(item => item.parentId != parentId);
                // console.log("tmepOtherData",tempOtherData);
                let rootNode = otherData
                    .filter(item => item.parentId == parentId)
                    .map(item => {
                        // const tempParentId = item.parentId;
                        // console.log("tempparntId",parentId,tempParentId);
                        return {
                            label: item.deptName,
                            value: item.id,
                            parentId: item.parentId,
                            params: item,
                            children: deepFunc(item.id, tempOtherData)
                        };
                    });
                console.log("每次返回的rootNode", rootNode);
                return rootNode;
            };
            result[0].children = deepFunc(parentId, sysDeptEntityList);
            state.deptList_tree = result;
        },
    },
    actions: {
        initCacheByReload(store) {//页面每次加载时需要重新加载在仓库中的各种数据
            // console.log("initCacheByReload", store.getters.getToken);
            if (!store.getters.getToken) return;
            store.dispatch("initPermission_menuList");
            store.dispatch("initAllAuthority_menuList");
            store.dispatch("initDept_List");
        },
        initLoginCache(store) {
            let token = $cache.getStore("token") || "";
            store.commit('setToken', token);
            let AuthorityMenu = $cache.getStore("AuthorityMenu");
            // let DynamicRoutes = $cache.getStore("DynamicRoutes");
            // console.log(" initLoginCache DynamicRoutes", DynamicRoutes);
            let userLoginInfo = $cache.getStore('userLoginInfo');
            (typeof AuthorityMenu == "string") && (AuthorityMenu = JSON.parse(AuthorityMenu));
            // typeof DynamicRoutes == "string" && (DynamicRoutes = JSON.parse(DynamicRoutes));
            typeof userLoginInfo == "string" && (userLoginInfo = JSON.parse(userLoginInfo));
            console.log("缓存token", token,);
            let flag = false;
            if (token) {
                flag = true;
                if (Array.isArray(AuthorityMenu)) {
                    store.commit("setAuthorityMenu", AuthorityMenu);
                    store.commit("setUserLoginInfo", userLoginInfo);
                    deepRouterFunc(AuthorityMenu);//动态菜单=>动态路由
                    const AuthorityBtns = renderAuthority(AuthorityMenu);//动态菜单=>动态权限
                    store.commit("setAuthorityBtnsByAllPage", AuthorityBtns);
                }
                store.dispatch("initCacheByReload");//更新仓库无状态数据
                console.log("Vuex initLoginCache");
            } else {
                Router.push("/login");
                store.commit("setAuthorityMenu", []);//清空权限菜单
                store.commit("setToken", "");
            }
            store.commit("setIsLogin", flag);
        },
        logOut(store) {//退出登录
            console.log("执行退出登录");
            $cache.removeStore("userLoginInfo");
            $cache.removeStore("token");
            $cache.removeStore("AuthorityMenu");
            store.commit("setLogout");
            Router.push("/login");
            store.commit("clearTag");
            Message({
                type: "success",
                message: "已退出登录!",
            })
        },
        initPermission_menuList(store) {//初始化用户权限列表
            $api.getPermissionMenuList().then(res => {
                store.commit("setPermission_menuList", res.data);
            });
        },
        initAllAuthority_menuList(store) {//初始化所有权限列表
            console.log("初始化所有权限列表");
            $api.getAllAuthorityMenuList().then(res => {
                console.log("初始化所有权限列表", res.data);
                store.commit("setAllAuthority_menuList", res.data);
            });
        },
        initDept_List(store) {//初始化所有部门列表
            $api.getDeptList().then(res => {
                store.commit("setDeptList", res.data);
                store.commit("setDeptList_formatTree", res.data);
            });
        },
    }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js